import store from '@/store'
import lib from '@/library'

export default {
  computed: {
    cduSingleEventsUltraWide () {
      return store.getters['bettingOfferState/getCduSingleEventsUltraWide']
    },

    cduSingleEvents () {
      if (lib.cdu.brands.isUltraWide()) {
        return this.cduSingleEventsUltraWide.filter(ev => ev.eventPage === this.currentRotateIndex)
      } else {
        return store.getters['bettingOfferState/getCduSingleEvents']
      }
    }
  },

  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/templates/SingleEvent.js